module.exports = __webpack_public_path__ + "media/images/favicon/android-chrome-192x192-76af85f84918c0ac21bdd1ab836173c6.png";